import { useEffect } from "react";

export function useFillWidth() {
  useEffect(() => {
    const setFillWidth = () => {
      const vw = window.document.body.clientWidth * 0.01;
      document.documentElement.style.setProperty("--vw", `${vw}px`);
    };

    let vw = window.innerWidth;
    const handleResize = () => {
      if (vw === window.innerWidth) return;
      vw = window.innerWidth;
      setFillWidth();
    };

    window.addEventListener("resize", handleResize);
    const timeoutId = setTimeout(() => setFillWidth, 10);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
}
